import React from 'react';
import './TestsResult.scss';

function TestsResult () {
        return (
            <div className="tests-result">
                <div className="result-content">
                    <h3 className="result-title title">Yakuniy test natijasi</h3>
                    <div className="result-info">
                        <p>Sarflangan vaqt: <span> 45 minut</span> </p>
                        <p>Savollar soni: <span>  32 ta </span></p>
                        <p>To'g'ri javoblar: <span> 25 ta </span></p>
                        <p>To'plagan Bali : <span> 54 %</span></p>
                    </div>
                    <p className="result-warning wrong ">
                        Siz yakuniy testdan talab qilingan balni to‘play olmadingiz.
                        Mavzularni qaytadan o‘rganib chiqing va qayta urinib kuring.
                    </p>
                    <a className="button button-primary result-btn">Javoblarni korish</a>
                </div>
                
            </div>
        );
}

export default TestsResult;
